import { useEffect, useState } from "react";

export default function useIsDarkTheme() {
  const getTheme = () => document.documentElement.getAttribute('data-bs-theme') === 'dark';
  const [isDark, setIsDark] = useState(getTheme);

  useEffect(() => {
    const observer = new MutationObserver(() => setIsDark(getTheme()));
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ['data-bs-theme'] });
    const handler = () => setIsDark(getTheme());
    document.addEventListener('theme-reload', handler);

    return () => {
      observer.disconnect();
      document.removeEventListener('theme-reload', handler);
    };
  }, []);

  return isDark;
}